import { createContext } from 'react';

interface ISettingsContext {
  isDuoEnabled: boolean;
}
export const SettingsContext = createContext<ISettingsContext>(
  {} as ISettingsContext
);
